import "../styles/BrowseByBudget.css";
import { Link } from "react-router-dom";
import lease from "../assets/images/lease.webp";
import twoM from "../assets/images/2m.webp";
import threeM from "../assets/images/3m.webp";
import fourM from "../assets/images/4m.webp";
import fiveM from "../assets/images/5m.webp";

const budgetCards = [
  {
    title: "Lease daily or weekly",
    image: lease,
    href: "/car-hire",
  },
  {
    title: "Under KSh 2M",
    image: twoM,
    href: "/inventory?priceMax=2000000",
  },
  {
    title: "Under KSh 3M",
    image: threeM,
    href: "/inventory?priceMax=3000000",
  },
  {
    title: "Under KSh 4M",
    image: fourM,
    href: "/inventory?priceMax=4000000",
  },
  {
    title: "Under KSh 5M",
    image: fiveM,
    href: "/inventory?priceMax=5000000",
  },
];

function BrowseByBudget() {
  return (
    <section className="browse-by-budget">
      <h2 className="browse-by-budget__title">
        Browse by budget
      </h2>

      <ul className="browse-by-budget__list">
        {budgetCards.map((card) => (
          <li className="browse-by-budget__item" key={card.title}>
            <Link
              to={card.href}
              className="budget-card"
              aria-label={card.title}
            >
              <div className="budget-card__image">
                <img
                  src={card.image}
                  alt=""
                  loading="lazy"
                />
              </div>

              <div className="budget-card__text">
                <span className="budget-card__title">
                  {card.title}
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default BrowseByBudget;